import React, { useContext, useEffect, useState } from "react";
import { ProductsList, ContentContainer, Recommendation } from "../../../../../styles/orderform.tsx";
import B2BProductCard from "../../components/b2b/b2bProductCard.tsx";
import { OrderContext } from "../../OrderContext.tsx";
import { getb2bRecommendation } from "../../../../../misc/helpers.ts";
import { Product } from "../../types.ts";
import { useTranslation } from "react-i18next";

function PhaseTwo() {

  const { products, formValues } = useContext(OrderContext);
  const { t } = useTranslation();
  const { preferences } = formValues
  const [suggestedProduct, setSuggestedProduct] = useState<Product | undefined>(undefined);
  const [filteredProducts, setFilteredProducts] = useState<Product[]>([]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0)
    }
    const suggestedProduct = getb2bRecommendation(preferences, products)
    setSuggestedProduct(suggestedProduct)
    setFilteredProducts(products.filter(product => product.name !== suggestedProduct?.name))
  }, [])

  return (
    <>
      {suggestedProduct && (
        <Recommendation>
          <h2>{t('phaseTwo.recommended')}</h2>
          <B2BProductCard
            product={suggestedProduct}
            horizontal
          />
        </Recommendation>
      )}

      <ContentContainer>
        <h3>{t('phaseTwo.otherOptions')}</h3>
        <ProductsList>
          <div className="products">
            {filteredProducts.map((product) => (
              <B2BProductCard
                key={product.hs_id}
                horizontal={false}
                product={product}
              />
            ))}
          </div>
        </ProductsList>
      </ContentContainer>
    </>
  )
}

export default PhaseTwo;
